import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { Schema } from '../../../../amplify/data/resource';
import CouponTable from './CouponTable/CouponTable';
import PaymentPlanTable from './PaymentPlanTable/PaymentPlanTable';
import { Switch } from '../../../components/custom/Switch';
import AddCouponDialog from './dialogs/AddCouponDialog';
import AddPaymentPlanDialog from './dialogs/AddPaymentPlanDialog';

// @ts-ignore
type Coupon = Schema['Coupon']['type'];
// @ts-ignore
type PaymentPlan = Schema['PaymentPlan']['type'];

const apiClient = generateClient<Schema>();

const Fees: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'coupons' | 'paymentPlans'>('paymentPlans');
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [paymentPlans, setPaymentPlans] = useState<PaymentPlan[]>([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);
  const [loadingPaymentPlans, setLoadingPaymentPlans] = useState(false);
  const [isAddCouponOpen, setIsAddCouponOpen] = useState(false);
  const [isAddPaymentPlanOpen, setIsAddPaymentPlanOpen] = useState(false);

  // Загрузка купонов
  const fetchCoupons = async () => {
    setLoadingCoupons(true);
    try {
      const { data: couponsData } = await apiClient.models.Coupon.list();
      setCoupons(couponsData || []);
    } catch (error) {
      console.error('Error fetching coupons:', error);
    } finally {
      setLoadingCoupons(false);
    }
  };

  // Загрузка планов платежей
  const fetchPaymentPlans = async () => {
    setLoadingPaymentPlans(true);
    try {
      const { data: paymentPlansData } = await apiClient.models.PaymentPlan.list();
      setPaymentPlans(paymentPlansData || []);
    } catch (error) {
      console.error('Error fetching payment plans:', error);
    } finally {
      setLoadingPaymentPlans(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'coupons') {
      fetchCoupons();
    } else {
      fetchPaymentPlans();
    }
  }, [activeTab]);

  const handleAddClick = () => {
    if (activeTab === 'coupons') {
      setIsAddCouponOpen(true);
    } else {
      setIsAddPaymentPlanOpen(true);
    }
  };

  const handleAddCoupon = (couponData: any) => {
    
    fetchCoupons(); 
  };

  const handleAddPaymentPlan = (paymentPlanData: any) => {
    
    fetchPaymentPlans(); 
  };

  return (
    <Box sx={{
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: '20px',
    }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ cursor: 'pointer' }}
            onClick={handleAddClick}
          >
            <img
              alt="logo"
              src={'/assets/client/add.svg'}
              style={{ width: '35px', height: '35px' }}

            />
            <Typography
              fontSize="30px"
              fontWeight="700"
              fontFamily={'AlmoniDL'}
            >
              {activeTab === 'coupons' ? 'הוסף קופון' : 'הוסף תוכנית תשלום'}
            </Typography>
          </Stack>
        </Box>
        <Stack direction="row-reverse" alignItems="center" spacing={6}>
          <Typography
            fontSize="30px"
            fontWeight="700"
            fontFamily={'AlmoniDL'}
            textAlign={'right'}
            sx={{ whiteSpace: 'nowrap' }}
          >
            תוכניות תשלום וקופונים
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              fontSize="14px"
              fontWeight="700"
              fontFamily={'AlmoniDL'}
              color={activeTab === 'paymentPlans' ? '#2E3A59' : '#999'}
            >
              תוכניות תשלום
            </Typography>
            <Switch
              checked={activeTab === 'coupons'}
              onChange={(e) => setActiveTab(e.target.checked ? 'coupons' : 'paymentPlans')}
            />
            <Typography
              fontSize="14px"
              fontWeight="700"
              fontFamily={'AlmoniDL'}
              color={activeTab === 'coupons' ? '#2E3A59' : '#999'}
            >
              קופונים
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: '#E7ECF1',
        }}
      />


      {/* Content */}
      {activeTab === 'coupons' ? (
        <CouponTable 
          coupons={coupons} 
          loading={loadingCoupons} 
          onCouponUpdated={fetchCoupons}
        />
      ) : (
        <PaymentPlanTable 
          paymentPlans={paymentPlans} 
          loading={loadingPaymentPlans} 
          onPaymentPlanUpdated={fetchPaymentPlans}
        />
      )}

      {/* Dialogs */}
      <AddCouponDialog
        open={isAddCouponOpen}
        onClose={() => setIsAddCouponOpen(false)}
        onSubmit={handleAddCoupon}
      />
      <AddPaymentPlanDialog
        open={isAddPaymentPlanOpen}
        onClose={() => setIsAddPaymentPlanOpen(false)}
        onSubmit={handleAddPaymentPlan}
      />
    </Box>
  );
};

export default Fees;
